export const GET_SUCCESS_CONFIGURATION_REQUEST = 'GET_SUCCESS_CONFIGURATION_REQUEST';
export const GET_SUCCESS_CONFIGURATION_SUCCESS = 'GET_SUCCESS_CONFIGURATION_SUCCESS';
export const GET_SUCCESS_CONFIGURATION__FAILED = 'GET_SUCCESS_CONFIGURATION__FAILED';
